export const BOOT_STEP_DESCRIPTION = {
    '0': 'Process takes 5 - 15 minutes',
    '1': 'Analyzing the image',
    '2': 'Loading image into machine',
    '3': 'Just a little more',
}

export const COMMAND_CODE = {
    CREATE_IMAGE: 0,
    BOOT_MACHINE: 1,
    SHUTDOWN: 2,
    SHUTDOWN_CLONE: 8
}